
import { defineComponent } from "vue";
import { CommandAction } from "@/utils/actions/CommandAction";

export default defineComponent({
  data() {
    return {};
  },

  props: {
    action: {
      type: Object as () => CommandAction,
      required: true
    }
  }
});
